"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMLOrFlOz = void 0;
var IMLOrFlOz;
(function (IMLOrFlOz) {
    IMLOrFlOz["ML"] = "mL";
    IMLOrFlOz["FlOz"] = "fl-oz";
})(IMLOrFlOz || (exports.IMLOrFlOz = IMLOrFlOz = {}));
//# sourceMappingURL=ml-or-fl-oz.js.map